var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"all"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"title"},[_vm._v("SCORE")]),_c('div',{staticClass:"num"},[_c('CountTo',{ref:"countTo",attrs:{"startVal":_vm.startVal,"endVal":_vm.score,"duration":_vm.duration,"autoplay":false}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }